import React, { useState, useEffect } from 'react';

import parse from 'html-react-parser';


import Hosts from '../../Hosts'
import {
	reqGET,
  set_language,
	content_language, 

} from '../../Utils';

const TermsConditions = () => {

    const [data, setData] = useState([]);

    const [lang, set_lang] = useState('pt');
    const [lang_id, set_lang_id] = useState('1');
    
    const [isloading, setLoading] = useState(true);
    

    let getInfo = async () => {

        reqGET(`${Hosts.SIMCore_API}/web/content/slug/${Hosts.companycode}/privacy-policy`)
            .then(res => { 
                setData(res.data)
                setLoading(false) 
            })
            .catch(erro => console.log('Erro', erro))  

    }   
    
    useEffect(() => { 
        getInfo()

        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

    }, []);

    return (isloading ?
      null
    :
      <div className={`container dash-cards body`}>
          <div className="row card px-5">
            {console.log('data', data)}
              {
              data.map((v, key) => {
                return (
                  <div className="col-12 card-body p-5" key={key}>
                      { 
                      (v.content[0].title !== '' || (v.content[0].language !== undefined && v.content[0].language[lang_id] !== undefined && v.content[0].language[lang_id] !== null && v.content[0].language[lang_id].title !== undefined && v.content[0].language[lang_id].title !== '')) ? 
                          <h2 className="dash-title mb-4">
                              {
                              lang === 'pt' || v.content[0].language === undefined ? 
                                  v.content[0].title 
                              : 
                                  (
                                  v.content[0].language[lang_id] !== undefined && v.content[0].language[lang_id]['title'] !== undefined && v.content[0].language[lang_id]['title'] !== '' ? 
                                      v.content[0].language[lang_id].title
                                  :
                                      v.content[0].title 
                                  )
                              }
                          </h2>
                      : 
                          null 
                      } 
                      
                      { (v.content[0].text !== '' || (v.content[0].language !== undefined && v.content[0].language[lang_id] !== undefined && v.content[0].language[lang_id] !== null && v.content[0].language[lang_id].text !== undefined && v.content[0].language[lang_id].text !== '')) ? (
                          <div className="div-group">
                              <span className="flex-1">
                              {parse(lang === 'pt' || v.content[0].language === undefined ? v.content[0].text : (v.content[0].language[lang_id] === undefined ||v.content[0].language[lang_id]['text'] === undefined || v.content[0].language[lang_id].text === '' ? v.content[0].text : v.content[0].language[lang_id].text))}
                              </span>
                          </div>
                      ) : null }                
                  </div>
                )
              })
              }
          </div>
      </div>     
    );

};
export default TermsConditions;

